module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-left-arrow-teal-3c4299a39a2ecd19f1325db829711a7c.svg";